import {
    DRE_AGUARDANDO,
    DRE_CARREGADO
} from './dreActions';

const INITIAL_STATE = {
    aguardando: false,
    itens: [],
    resumo: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DRE_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };
        case DRE_CARREGADO:
            return {
                ...state,
                itens: action.payload.itens || [],
                resumo: action.payload.resumo || {}
            };
        default:
            return state;
    }
};
